import { literal, object, type InferOutput } from 'valibot'
import { Engine } from '../../../../engine/Engine.type'
import { HorizontalOrVertical, HorizontalOrVerticalSchema } from '../../../../entity/EntityHeading/HorizontalOrVertical.enum'
import { TilePositionXYSchema, type TilePositionXY } from '../../../../tile_position_xy/TilePositionXY.type'
import type { ActionLog } from '../../ActionLog.type'
import { ActionType } from '../ActionType'

export const RownipulatorDeleteRowActionSchema = object({
  type: literal(ActionType.Map.RownipulatorDeleteRow),
  position: TilePositionXYSchema,
  orientation: HorizontalOrVerticalSchema,
})

export type RownipulatorDeleteRowAction = InferOutput<typeof RownipulatorDeleteRowActionSchema>

export function createRownipulatorDeleteRowAction(position: TilePositionXY, orientation: HorizontalOrVertical): RownipulatorDeleteRowAction {
  return {
    type: ActionType.Map.RownipulatorDeleteRow,
    position,
    orientation,
  }
}

export async function handleRownipulatorDeleteRowAction(
  engine: Engine,
  action: RownipulatorDeleteRowAction,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  actionLog: ActionLog
): Promise<void> {
  const { position, orientation } = action

  const { state } = engine
  const { ents, width, height } = state

  if (orientation === HorizontalOrVertical.Horizontal) {
    const y = position.y

    if (height <= 1) return // Prevent deleting last row

    // Remove entities in the target row
    for (let i = ents.length - 1; i >= 0; i--) {
      if (ents[i].y === y) {
        ents.splice(i, 1)
      }
    }

    // Shift down entities above the deleted row
    for (const ent of ents) {
      if (ent.y > y) {
        ent.y -= 1
      }
    }

    state.height -= 1

  } else if (orientation === HorizontalOrVertical.Vertical) {
    const x = position.x

    if (width <= 1) return // Prevent deleting last column

    // Remove entities in the target column
    for (let i = ents.length - 1; i >= 0; i--) {
      if (ents[i].x === x) {
        ents.splice(i, 1)
      }
    }

    // Shift left entities right of the deleted column
    for (const ent of ents) {
      if (ent.x > x) {
        ent.x -= 1
      }
    }

    state.width -= 1

  } else {
    throw new Error("Unknown orientation in delete row action")
  }
}
